import { PessoaCatalogoService } from 'src/app/services/geral/pessoa-catalogo.service';
import { PessoaCatalogo } from 'src/app/model/geral/pessoaCatalogo';
import { Component, Injector, OnInit } from '@angular/core';
import { PessoaListaModule } from '../../pessoa/listas/pessoalista.module';
import { ListaSimplesGenerica } from '../../generic/listagenerica/listasimplesgenerica';

@Component({
  selector: 'app-lista-pessoacatalogo',
  templateUrl: '../../generic/listagenerica/listasimples.component.html',
  styleUrls: [ '../../generic/listagenerica/listasimples.component.css']
})

export class ListaPessoaCatalogoComponent extends ListaSimplesGenerica<PessoaCatalogo> implements OnInit {

  override obj = new PessoaCatalogo();

  constructor(
    injectorObj: Injector,
    api: PessoaCatalogoService) 
  {
    super(injectorObj, api);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraList(res: any) {
}

  override getColorCell(valor: any) {   
  }

}
